export enum TOOLBAR_BUTTON {
    REDO = 're_do',
    UNDO = 'un_do',
    ROTATE_CLOCKWISE = 'rotate_clockwise',
    ROTATE_COUNTERCLOCKWISE = 'rotate_counterclockwise',
    REMOVE = 'remove',
    DUPLICATE = 'duplicate',
    ZOOM_IN = 'zoom_in',
    ZOOM_OUT = 'zoom_out',
    ZOOM_TO_FIT = 'zoom_to_fit',
}

export enum TOOLBAR_GROUPS {
    MAIN_TOOLBAR = 'main_toolbar',
    ZOOM_TOOLBAR = 'zoom_toolbar',
}
